import React, {useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Image2 from './images/Image2';
import { useNavigate } from 'react-router-dom';
import { getSessionStorage } from '../utils/StorageUtil';
import { ACCOUNT_SO_KEY, USER_SO_KEY, cleanSOData } from '../utils/accountUtils';
import ProfileAvatar from './ProfileAvatar';
import ProfileContext from '../pages/private/profile/ProfileContext';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Button from '@mui/material/Button';
import { Trans } from 'react-i18next';
import LoginIcon from '@mui/icons-material/Login';
import pkg from '../../package.json';
  
const menu = {
  'boxShadow': '0px 4px 4px rgba(0, 0, 0, 0.25)',
  'borderRadius': '0px 0px 5px 5px'
}

type Props = {
  title?: string,
  selectedOptionIndex?: number
}

export default function (props: Props) {
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();

  const handleLogOut = () => {
    cleanSOData()
    navigate('/web/login', { replace: true })
  }

  const handleChangePassword = () => {
    navigate('/web/change-password', { replace: true })
  }

  const handleProfile = () => {
    navigate('/web/profile', { replace: true })
  }

  const handleCatalog = () => {
    navigate('/web/catalog', { replace: true })
  }

  const handleSearchCatalog = () => {
    navigate('/web/search-vehicles', { replace: true })
  }

  const handleIndicators = () => {
    navigate('/web/', { replace: true })
  }

  const handleLogin = () => {
    navigate('/web/login', { replace: true })
  }

  const settings = [
    {
      'name': 'Mi perfil',
      'action': handleProfile,
      'disableCondition': (): boolean => {
        const user = getSessionStorage(USER_SO_KEY)
        return user?.role === 'CHOFER'
      }
    },
    {
      'name': 'Cambiar contraseña',
      'action': handleChangePassword
    },
    { 'name': 'Cerrar sesión',
      'action': handleLogOut
    }
  ];

  const menuSettings = [
    {
      'name': 'Inicio',
      'action': handleIndicators
    },
    {
      'name': 'Catálogo OLCA',
      'action': handleCatalog
    },
    { 'name': 'Buscar Vehículo',
      'action': handleSearchCatalog
    }
  ];

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };
  const version = pkg.version;
  return (
    <ProfileContext.Consumer>
      {(context) => {
        const safeNavigate = (callback: any) => {
          if (props.selectedOptionIndex === 0 && context.editing) {
            context.setDialogOpen(true)
            context.onCloseDialog = callback
          } else {
            callback()
          }
        }

        return (
          <Box>
            <AppBar position="static" className='profile-header'>
              <Container maxWidth="xl" sx={{padding: '0 3%'}}>
                <Toolbar disableGutters>
                  <Box onClick={() => safeNavigate(handleIndicators)} sx={{cursor: 'pointer'}}>
                    <Image2></Image2>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}/>
                  { getSessionStorage(ACCOUNT_SO_KEY) === null &&
                    <Button endIcon={<LoginIcon />} onClick={handleLogin} className="profile-header-log-in-button">
                      <Trans i18nKey={`screens.appHeader.logInButton`}></Trans>
                    </Button>
                  }
                  { getSessionStorage(ACCOUNT_SO_KEY) !== null &&
                    <Box className="profile-header-buttons">
                      {/* <Box>
                        <IconButton color="primary" aria-label="upload picture" component="label" onClick={handleOpenMenu}>
                          <MenuIcon />
                        </IconButton>
                      </Box> */}
                      <Box sx={{display: 'flex', cursor: 'pointer'}} onClick={handleOpenUserMenu}>
                        <Box className='profile-username-text' sx={{color: {xs: '#FFFFFF', sm: '#272C31', md: '#272C31', lg: '#272C31', xl: '#272C31' }}}>{getSessionStorage(ACCOUNT_SO_KEY).firstName}</Box>
                        <ProfileAvatar diameter={32} borderSx='2px solid #FFFFFF'></ProfileAvatar>
                      </Box>
                    </Box>
                  }
                </Toolbar>
              </Container>
            </AppBar>
            {
              !!props.title && <Box>
                <p className="formTitle" style={{margin: '57px 0 0'}}>{props.title}</p>
                <Divider sx={{margin: '17px 6% 20px', display: 'block', background: '#008F39'}} variant="middle" />
              </Box>
            }
            <Menu
              sx={menu}
              id="menu-user"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting, index) => (
                <Box key={index}>
                  <MenuItem disabled={props.selectedOptionIndex === index || (!!setting.disableCondition && setting.disableCondition())} onClick={() => safeNavigate(setting.action)}>
                    <Box sx={{ flexGrow: 1 }}></Box>
                    <Typography>{setting.name}</Typography>
                  </MenuItem>
                  { settings[index+1] && <Divider /> }
                </Box>
              ))}
            </Menu>
            <Menu
              sx={menu}
              id="menu-appbar"
              anchorEl={anchorElMenu}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElMenu)}
              onClose={handleCloseMenu}
            >
              {menuSettings.map((setting, index) => (
                <Box key={index}>
                  <MenuItem onClick={() => safeNavigate(setting.action)}>
                    <Box sx={{ flexGrow: 1 }}></Box>
                    <Typography>{setting.name}</Typography>
                  </MenuItem>
                  { menuSettings[index+1] && <Divider /> }
                </Box>
              ))}
            </Menu>
            <Box
              sx={{
                position: 'fixed',
                bottom: 8,
                right: 16,
                fontSize: 12,
                color: '#999999',
                zIndex: 9999
              }}
            >
              v{version}
            </Box>

          </Box>
        )
      }}
    </ProfileContext.Consumer>
  );
}